<div class="www-ord">
  @if (events().length) {
    <section class="container www-ord__con">
      <div class="www-ord__con__box">
        <div class="www-ord__con__sec">
          <div class="www-ord__con__sec__row">
            <div class="www-ord__con__sec__col www-ord__con__sec__col--lef">
              <form
                [formGroup]="formGroup"
                [ngxsForm]="'account.form'"
                [ngxsFormClearOnDestroy]="_isBrowser"
                novalidate
                ngxsFormDebounce="200"
              >
                <div class="www-ord__con__sec__col www-ord__con__sec__col__form">
                  <h3 class="www-ord__con__sec__sub-tit">DANE OSOBOWE</h3>

                  <div
                    class="www-form www-form-disabled www-ord__sec__form"
                    [appAnimate]="'fadeInLeft'"
                    [speed]="'fast'"
                  >
                    <div class="row">
                      <div class="col-12">
                        <div class="group">
                          <input
                            [appInputValidator]="f.firstname"
                            [formControlName]="'firstname'"
                            id="firstname"
                            type="text"
                            autocomplete="off"
                          />
                          <label class="www-form-disabled__dis" for="firstname">Imię</label>
                        </div>
                        <app-validate-message [control]="f.firstname" />
                      </div>

                      <div class="col-12">
                        <div class="group">
                          <input class="used" [formControlName]="'lastname'" id="lastname" type="text" />
                          <label class="www-form-disabled__dis" for="lastname">Nazwisko</label>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="group">
                          <input
                            [appInputValidator]="f.mobile"
                            [formControlName]="'mobile'"
                            id="mobile"
                            type="text"
                            autocomplete="off"
                            [mask]="'00 000 000 000'"
                          />
                          <label class="www-form-disabled__dis" for="mobile">Nr telefonu</label>
                        </div>
                        <app-validate-message [control]="f.mobile" />
                      </div>

                      <div class="col-12">
                        <div class="group">
                          <input
                            [appInputValidator]="f.email"
                            [formControlName]="'email'"
                            id="email"
                            type="text"
                            autocomplete="off"
                          />
                          <label class="www-form-disabled__dis" for="email">Adres e-mail</label>
                        </div>
                        <app-validate-message [control]="f.email" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="www-ord__con__sec__col www-ord__con__sec__col__form">
                  <h3 class="www-ord__con__sec__sub-tit">DANE DO FAKTURY</h3>

                  <div
                    class="www-form www-form-disabled www-ord__sec__form"
                    appInvalidControlScroll
                    [appAnimate]="'fadeInLeft'"
                    [speed]="'fast'"
                  >
                    <div class="row">
                      <div class="col-12">
                        <div class="group">
                          <input
                            [appInputValidator]="f.invoiceNip"
                            [formControlName]="'invoiceNip'"
                            id="invoiceNip"
                            type="text"
                            autocomplete="off"
                            [mask]="'000 0000 000'"
                          />
                          <label class="www-form-disabled__dis" for="invoiceNip">NIP</label>
                        </div>
                        <app-validate-message [control]="f.invoiceNip" />
                      </div>

                      <div class="col-12">
                        <div class="group">
                          <input class="used" [formControlName]="'invoiceStreet'" id="invoiceStreet" type="text" />
                          <label class="www-form-disabled__dis" for="invoiceStreet">Ulica</label>
                        </div>
                        <app-validate-message [control]="f.invoiceStreet" />
                      </div>

                      <div class="col-12">
                        <div class="group">
                          <input
                            [appInputValidator]="f.invoiceZipCode"
                            [formControlName]="'invoiceZipCode'"
                            id="invoiceZipCode"
                            type="text"
                            autocomplete="off"
                            [mask]="'00-000'"
                          />
                          <label class="www-form-disabled__dis" for="invoiceZipCode">Kod pocztowy</label>
                        </div>
                        <app-validate-message [control]="f.invoiceZipCode" />
                      </div>

                      <div class="col-12 mb-4">
                        <div class="group">
                          <input
                            [appInputValidator]="f.invoiceCity"
                            [formControlName]="'invoiceCity'"
                            id="invoiceCity"
                            type="text"
                            autocomplete="off"
                          />
                          <label class="www-form-disabled__dis" for="invoiceCity">Miejscowość</label>
                        </div>
                        <app-validate-message [control]="f.invoiceCity" />
                      </div>

                      <div class="col-12 mb-3">
                        <div class="group">
                          <input
                            type="checkbox"
                            id="agreementPayment"
                            [appInputValidator]="f.agreementPayment"
                            [formControlName]="'agreementPayment'"
                          />
                          <label for="agreementPayment"
                            >Oświadczam, że zgadzam się z&nbsp;poniższymi postanowieniami w&nbsp;zakresie opłat za
                            wydarzenie<sup>*</sup>:</label
                          >
                          <app-validate-message [control]="f.agreementPayment" />
                        </div>
                      </div>

                      <div class="col-12 www-ord__con__wrb">
                        <ol class="www-ord__con__wrb__ol">
                          <li class="www-ord__con__wrb__ol__li">
                            Opłata za udział w Wydarzeniu nastąpi na podstawie faktury VAT wystawionej przez L’Oréal
                            Polska Sp. z o.o., na podstawie powyższych danych zawartych w formularzu rezerwacji miejsca
                            na Wydarzeniu.
                          </li>
                          <li class="www-ord__con__wrb__ol__li">
                            Wszelkie dodatkowe koszty powstałe po stronie Uczestnika (w tym indywidualne zamówienia,
                            dojazdy, posiłki) są pokrywane indywidualnie, bezpośrednio przez Uczestnika.
                          </li>
                          <li class="www-ord__con__wrb__ol__li">
                            Uczestnik może zrezygnować z udziału w Wydarzeniu bez opłat, pod warunkiem wysłania
                            informacji o rezygnacji z udziału na adres mailowy:
                            <a href="mailto:loreal@h2h.tech">loreal&#64;h2h.tech</a> na minimum 14 dni przed
                            Wydarzeniem. W przypadku dokonania rezygnacji w terminie krótszym niż na 14 dni przed
                            Wydarzeniem, Uczestnik zobowiązany będzie do dokonania opłaty zgodnie ze zgłoszeniem w
                            trakcie rezerwacji miejsca na Wydarzenie. Powyższe nie dotyczy sytuacji losowych
                            niezależnych od Uczestnika, po przedstawieniu odpowiedniego zaświadczenia przez Uczestnika.
                          </li>
                        </ol>
                        <small class="www-ord__con__wrb__sma">*obowiązkowe</small>
                      </div>

                      <div class="col-12 d-flex justify-content-center justify-content-md-start">
                        <button class="www-ord__con__btn" [disabled]="cartBtnBlock()" (click)="order()">
                          Zrealizuj
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="www-ord__con__sec__col www-ord__con__sec__col--rig">
              <h3 class="www-ord__con__sec__sub-tit">TWOJE ZAMÓWIENIE</h3>

              @for (e of events(); track $index) {
                <div class="www-ord__con__sec__ord">
                  <img class="www-ord__con__sec__ord__img" [src]="e.photo" [alt]="e.photo" />
                  <div class="www-ord__con__sec__ord__text">
                    <label>SZKOLENIE</label>
                    <p>
                      {{ e.name }}
                    </p>
                    <label>DATA</label>
                    <p>
                      {{ e.start_date | date: 'dd/MM/yyyy' }}&nbsp;|&nbsp;{{ e.start_date | date: 'HH:mm' }} -
                      {{ e.end_date | date: 'HH:mm' }}
                    </p>

                    @if (e.place) {
                      <label>MIEJSCE</label>
                      <p>{{ e.place.city }}, {{ e.place.address }}, {{ e.place.name }}</p>
                    }
                    <label>ILOŚĆ BILETÓW</label>
                    <div class="www-ord__con__sec__ord__text__tickets">
                      <a class="remove" [ngClass]="{ inactive: e.places <= 1 }" (click)="removePlace(e)">-</a>
                      <p>{{ e.places }}</p>
                      <a class="add" [ngClass]="{ inactive: e.places === e.free_seats }" (click)="addPlace(e)">+</a>
                    </div>

                    <label>CENA</label>
                    @if (e.price === 0) {
                      <p>Szkolenie bezpłatne</p>
                    } @else {
                      @if (user()) {
                        <p>
                          <s>{{ e.price + ' PLN' }}</s
                          >&nbsp;{{
                            user()?.type === UserType.MEMBER
                              ? (e.price * 0.9 | mask: 'separator.2') + ' PLN'
                              : (e.price * 0.8 | mask: 'separator.2') + ' PLN'
                          }}
                        </p>
                      } @else {
                        <p>{{ e.price > 0 ? e.price + ' PLN' : 'Szkolenie bezpłatne' }}</p>
                      }
                    }

                    <div class="row mt-2">
                      <div class="col-12 d-flex justify-content-end">
                        <a class="www-ord__con__sec__ord__text__rm" (click)="removeEvent(e)">USUŃ Z KOSZYKA</a>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div class="www-ord__con__sec__sum">
                <div>
                  <label>SUMA ŁĄCZNA</label>
                  <p>{{ summPrice() ? (summPrice()! | mask: 'separator.2') + ' PLN' : '0 PLN' }}</p>
                </div>
                <div>
                  @if (user()) {
                    <label>RABAT {{ user()!.type === UserType.ELITE ? 'ELITE' : 'MEMBER' }}</label>
                    <p>
                      {{ user()!.type === UserType.ELITE ? '20%' : '10%' }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  } @else {
    <div class="row">
      <div class="col-12 d-flex justify-content-center align-items-center empty-cart">Brak zamówień w koszyku</div>
    </div>
  }
</div>
